import { FC } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Summary from "./QuoteSummary";
import PolicyHolderDetails from "./PolicyHolderDetails";
import ProposerSummary from "./ProposerSummary";
import Terms from "./Terms";

type Props = {
  onNext: VoidFunction | null;
  onPrevious: VoidFunction | null;
  onSubmit: VoidFunction | null;
};

const BindRoutes: FC<Props> = props => (
  <Routes>
    <Route path="quote-summary" element={<Summary {...props} />} />
    <Route path="proposer-details" element={<PolicyHolderDetails {...props} />} />
    <Route path="proposer-summary" element={<ProposerSummary {...props} />} />
    <Route path="terms" element={<Terms {...props} />} />
    <Route path="*" element={<Navigate to="/au/group_travel/retrieve-list" />} />
  </Routes>
);

export default BindRoutes;
